<template>
    <transition name="over">
        <div v-if="visible" class="transparent-overlay" @click.self="handleClick" :style="{ backgroundColor: bgColor,top: fixedTop}">
            <!-- <div class="transparent-overlay-content" > -->
            <slot></slot>
            <!-- </div> -->
        </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      bgColor: {
        type: String,
        default: 'transparent'
      },
     
      clickOutsideToHide: {
        type: Boolean,
        default: true
      },
      fixedTop:{
        type: String,
        default:'0'
      }

    },
    data(){
      return{
        overlay:{
          top:this.fixedTop,
        },
      }
    },
    methods: {
      handleClick() {
        if (this.clickOutsideToHide) {
            // 相当于父组件执行了visible = false
            this.$emit('update:visible', false);
        }
      }
    },
  };
  </script>
  
  <style scoped>
  .transparent-overlay {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  
  /* .transparent-overlay-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    border-radius: 5px;
  } */
  .over-enter-active,
  .over-leave-active {
    transition: opacity 0.3s ease-in-out;
  }
  .over-enter,.over-leave-to {
    opacity: 0;
  }
  .over-enter-to,.over-leave {
    opacity: 1;
  }
  </style>
  